<template>
    <div class="main-content main-content--wizzard">
        <h1 v-translate>
            Plan new objective/goal
        </h1>
        <div class="steps__container" v-if="stepLocation != 'introduction'">
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-1'}">
                <strong v-translate>Objective info</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-2'}">
                <strong v-translate>Activities</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-3'}">
                <strong v-translate>Define each activity</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-4'}">
                <strong v-translate>Review and reminders</strong>
            </div>
        </div>

        <plan-objective-step-one :parent_objective="objective" v-if="stepLocation == 'step-1'" @advance="changeStep"/>

        <plan-objective-step-two :parent_objective="objective" v-if="stepLocation == 'step-2'" @advance="changeStep"/>

        <plan-objective-step-three :parent_objective="objective" v-if="stepLocation == 'step-3'" @advance="changeStep"/>

        <plan-objective-step-four :parent_objective="objective" v-if="stepLocation == 'step-4'" @advance="changeStep"
                                  @add="addObjective"/>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import ChooseDate from "./popups/ChooseDate";
    import PlanObjectiveStepOne from "./PlanObjectiveStepOne";
    import PlanObjectiveStepTwo from "./PlanObjectiveStepTwo";
    import PlanObjectiveStepThree from "./PlanObjectiveStepThree";
    import PlanObjectiveStepFour from "./PlanObjectiveStepFour";
    import axios from 'axios';
    import PackageFeatureRequired from "../mixins/PackageFeatureRequired";

    export default {
        components: {PlanObjectiveStepFour, PlanObjectiveStepThree, PlanObjectiveStepTwo, PlanObjectiveStepOne},
        mixins: [PackageFeatureRequired('plan_your_objectives')],
        data() {
            return {
                stepLocation: 'step-1',
                showAddNewActivityForm: false,
                showEditActivityForm: false,
                showReviewActivityDetails: false,
                choose_date: ChooseDate,
                objective: {
                    name: '',
                    description: '',
                    color: '',
                    activities: [],
                    reminders: [{
                        reminder_data: {
                            via: 'email',
                            when: 1,
                            what: 'days'
                        }
                    }]
                }
            }
        },
        methods: {
            ...mapActions([
                'openPopup'
            ]),
            changeStep: function (step) {
                this.stepLocation = step;
            },
            addObjective: async function () {
                let fixed_reminders = []
                for (let i = 0; i < this.objective.reminders.length; i++) {
                    fixed_reminders.push(this.objective.reminders[i].reminder_data)
                }
                for (let i = 0; i < this.objective.activities.length; i++) {
                    this.objective.activities[i].reminders = fixed_reminders
                }
                delete this.objective.reminders
                await axios.post('/api/navigator/objectives/', this.objective)
                this.$router.push({name: 'my-objectives-goals'})
            }
        },
        beforeMount: function () {
            this.objective.color = Math.floor(Math.random() * (20 - 1 + 1)) + 1;
        }
    }
</script>